module.exports = __webpack_public_path__ + "static/media/icon-live-ic-eye.13049371.svg";